import { AUTH_COMPLETE_PATH, type SportsFiApp, buildSportsFiAppSelectorUrl } from '@/lib/auth/appAccess';

export const AUTH_SESSION_ERROR_QUERY_PARAM = 'sessionError';
export const AUTH_SESSION_ERROR_INVALID_VALUE = 'invalid';
export const AUTH_FRESH_SIGN_IN_QUERY_PARAM = 'freshAuth';
export const AUTH_FRESH_SIGN_IN_QUERY_VALUE = '1';

type LoginPathOptions = {
  freshAuth?: boolean;
};

export function getLoginPathWithReturnUrl(returnUrl = window.location.href, options: LoginPathOptions = {}): string {
  const loginUrl = new URL('/login', window.location.origin);

  loginUrl.searchParams.set('callbackUrl', returnUrl);

  if (options.freshAuth === true) {
    loginUrl.searchParams.set(AUTH_FRESH_SIGN_IN_QUERY_PARAM, AUTH_FRESH_SIGN_IN_QUERY_VALUE);
  }

  return `${loginUrl.pathname}${loginUrl.search}`;
}

export function getAuthCleanupPathWithLoginPath(loginPath: string): string {
  const cleanupUrl = new URL('/api/session/clear-auth', window.location.origin);

  cleanupUrl.searchParams.set('callbackUrl', loginPath);

  return `${cleanupUrl.pathname}${cleanupUrl.search}`;
}

export function getAuthCleanupPathWithLoginReturnUrl(returnUrl = window.location.href): string {
  return getAuthCleanupPathWithLoginPath(getLoginPathWithReturnUrl(returnUrl, { freshAuth: true }));
}

export function getAuthSessionErrorPathWithReturnUrl(returnUrl = window.location.href): string {
  const sessionErrorUrl = new URL(AUTH_COMPLETE_PATH, window.location.origin);

  sessionErrorUrl.searchParams.set('returnUrl', returnUrl);
  sessionErrorUrl.searchParams.set(AUTH_SESSION_ERROR_QUERY_PARAM, AUTH_SESSION_ERROR_INVALID_VALUE);

  return `${sessionErrorUrl.pathname}${sessionErrorUrl.search}`;
}

export function getUnauthorizedPathWithReturnUrl(
  _app: SportsFiApp,
  _reason: 'missing-role' | 'missing-organisation' = 'missing-role',
  returnUrl = window.location.href
): string {
  return buildSportsFiAppSelectorUrl({ currentLocation: window.location, returnUrl });
}
